
define(
    'jsx!components/ideas-lab/ideas-lab-content',[
   	"jquery",
	"underscore",
	"backbone",
    "react",
    "shared/connect-to-actions",
	"shared/connect-to-stores",
    "shared/client",
    "actions/ideas-lab",
    "jsx!components/modal/duplicate-buncee",
    "jsx!components/ideas-lab/ideas-lab-detail",
    ], 
    function ($, _, Backbone, React, ConnectToActions, ConnectToStores, Client, IdeasLabAction, DuplicateBunceeModal, IdeasLabDetail){
        return React.createClass({
            displayName: "IdeasLab",
            getDefaultProps: function ()
            {
                return {
                    "onBookmarkedClick": function () {},
                    "onClick": function () {},
                    "results": [],
                    "favorites": [],
                };
            },
            onCreateThisClick: function(idea) 
            {  
                if (!window.appData.user) {
                    window.location = "/login?return_to=/ideas-lab";
                    return;
                }
                
                var modal = React.createElement(DuplicateBunceeModal, {
                    buncee_guid: idea.id,
                    url: idea.content.templateURL,
                    trackIdea: function()  {
                        this.props.trackIdea(idea.id, "create");
                    }.bind(this)
                });
                React.render(modal, document.getElementById('buncee-modal'));
    
            },
            onBookmarkedClick: function (assetGuid) {
                if (!window.appData.user) {
                    window.location = "/login?return_to=/ideas-lab";
                    return;
                }
                var self = this;
                this.actions = {"ideas-lab" : new IdeasLabAction()};
                var actionIdeaslab = ConnectToActions["ideas-lab"];
                actionIdeaslab.updateBookmarked(assetGuid, function (state = false) {
                    if(state) {
                        self.props.trackIdea(assetGuid, "bookmark");
                    }
                    self.props.onBookmarkedClick();
                });

            },
            renderThumbnail: function (result) {
                var self = this;
                if (result.entity_url.indexOf("boards") > -1) {
                    return React.createElement("img", {id: "content-thumbnail", src: result.entity_url, alt: result.alt_text});
                } else {
                    return React.createElement("img", {id: "content-thumbnail", src: result.thumbnails[0], alt: result.alt_text});
                }
            },
            render: function ()
            {
                var self = this;
                return( React.createElement("div", {className: "contents", id: "contents"}, 
                
                    _.map(this.props.results, function (result) {
                        return (
                            React.createElement("div", {className: "content-detail"}, 
                                React.createElement("div", {className: "content-thumbnail-wrapper", onClick: function () { self.props.onClick(result.id); }}, 
                                    self.renderThumbnail(result)
                                ), 
                                React.createElement(IdeasLabDetail, {
                                    buncee: result, 
                                    onCreateThisClick: self.onCreateThisClick, 
                                    onBookmarkedClick: self.onBookmarkedClick, 
                                    onClick: self.props.onClick, 
                                    favorites: self.props.favorites, 
                                    openFrom: "content", 
                                    trackIdea: self.props.trackIdea}
                                )
                            )
                        );
                    })
                
                ));
            }    
        });
    }
);
